import {atom} from "recoil"

const showTransactionModalState = atom({
  key:'showTransactionModal',
  default: false
})

export default showTransactionModalState